import React, { useState } from "react";
import "./contact.css";
import emailjs from "emailjs-com";
import { useMediaQuery } from "react-responsive";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const Contact = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    mobile: "",
    email: "",
    inqueryType: "",
    details: "",
  });
  const [isSending, setIsSending] = useState(false);

  const isFormValid =
    formData.name &&
    formData.companyName &&
    formData.mobile &&
    formData.details &&
    formData.inqueryType &&
    formData.email;

  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    details: "",
  });

  const validateMobile = (mobile) => {
    const mobileRegex = /^[0-9]{11}$/;
    return mobileRegex.test(mobile);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, mobile, details, companyName, email, inqueryType } = formData;

    if (!validateMobile(mobile)) {
      setErrors({ ...errors, mobile: "Invalid mobile number" });
      return;
    }

    setIsSending(true);

    try {
      const emailData = {
        name,
        mobile,
        details,
        companyName,
        email,
        inqueryType,
      };

      console.log("EmailJS Data:", emailData);

      emailjs
        .send(
          "service_ukwpswk",
          "template_qaps4ud",
          emailData,
          "eustvQeLOCU86kDQW"
        )
        .then(
          (response) => {
            console.log("Message sent successfully:", response);
            setIsSending(false);
            setFormData({
              name: "",
              mobile: "",
              details: "",
              inqueryType: "",
              companyName: "",
              email: "",
            });
          },
          (error) => {
            console.error("Failed to send message:", error);
            setIsSending(false);
          }
        );
    } catch (error) {
      console.error("Error uploading files:", error);
      setIsSending(false);
    }
  };

  return (
    <section className="contact page">
      {isMobile ? (
        <div className="Mobile-version">
          <div className="contact-container">
            <div className="title">
              <h1>
                Stay In <span className="title-word">Touch</span>
              </h1>
            </div>
            <div className="box box-1">
              <div className="box-right">
                <div className="text-box">
                  <h1>Social Media </h1>
                  <div className="image-box">
                    <LazyLoadImage
                      src={require("../../assets/blog-5.jpg")}
                      alt="About us Picture"
                      effect="blur"
                    />
                  </div>
                  <p>
                    Stay connected with <span className="desc-word"> CSL </span>
                    on social media for the latest updates, exclusive offers,
                    and more. Follow us on Facebook, Instagram, X, YouTube and
                    TikTok to join our growing community and never miss a moment
                    of inspiration, innovation, and connection. Together, we
                    grow and create!
                  </p>
                  <a
                    href="https://www.facebook.com/CreativeScaleLab"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="btn">Follow Us Now!</button>
                  </a>
                </div>
              </div>
            </div>
            <div className="contact-info">
              <h1>Contact Information</h1>
              <div className="cards-box">
                <div className="info-card">
                  <h3>Email Address</h3>
                  <h5>Faris Megahed</h5>
                  <small>Executive Assistant</small>
                  <a href="mailto:Management@creativescalelab.org">
                    <button className="btn">
                      Management@creativescalelab.org
                    </button>
                  </a>
                </div>
                <div className="info-card">
                  <h3>Email Address</h3>
                  <h5>James Anderson</h5>
                  <small>Executive Assistant</small>
                  <button className="btn">+1 (555) 123-4567</button>
                </div>
              </div>
            </div>
            <div className="form-container">
              <div className="form-left">
                <div className="text-box">
                  <h1>
                    Bring your vision to life! Fill in your
                    <span className="title-word">Contact</span>
                    details now, and let’s start elevating your brand!
                  </h1>
                </div>
              </div>
              <div className="form-right">
                <form onSubmit={handleSubmit}>
                  <div className="row-1">
                    <div className="input-box">
                      <input
                        name="name"
                        type="text"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-box">
                      <input
                        name="companyName"
                        type="text"
                        placeholder="Company Name"
                        value={formData.companyName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-2">
                    <div className="input-box">
                      <input
                        name="mobile"
                        type="text"
                        placeholder="Phone Number"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-3">
                    <div className="input-box">
                      <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-4">
                    <select
                      name="inqueryType"
                      value={formData.inqueryType}
                      onChange={handleChange}
                    >
                      <option value="">Inquiry Type</option>
                      <option value="UI/UX Design">UI/UX Design</option>
                      <option value="Graphic Design">Graphic Design</option>
                      <option value="SEO & SEM">SEO & SEM</option>
                      <option value="Video Editing">Video Editing</option>
                      <option value="Content Creation">Content Creation</option>
                      <option value="Social Media Management">
                        Social Media Management
                      </option>
                      <option value="Motion Graphics">Motion Graphics</option>
                      <option value="Paid Social Media Advertising">
                        Paid Social Media Advertising
                      </option>
                      <option value="Digital Marketing">
                        Digital Marketing
                      </option>
                      <option value="None of the above">
                        None of the above
                      </option>
                    </select>
                  </div>
                  <div className="row-5">
                    <div className="input-box">
                      <textarea
                        placeholder="Write your message here..."
                        name="details"
                        value={formData.details}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <button
                    className="btn"
                    type="submit"
                    disabled={!isFormValid || isSending}
                    style={{
                      opacity: isFormValid ? 1 : 0.5,
                      pointerEvents: isFormValid ? "auto" : "none",
                    }}
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="contact-container">
            <div className="title">
              <h1>
                Stay In <span className="title-word">Touch</span>
              </h1>
            </div>
            <div className="box box-1">
              <div className="box-left">
                <div className="image-box">
                  <LazyLoadImage
                    src={require("../../assets/blog-5.jpg")}
                    alt="About us Picture"
                    effect="blur"
                  />
                </div>
              </div>
              <div className="box-right">
                <div className="text-box">
                  <h1>Social Media </h1>
                  <p>
                    Stay connected with CSL on social media for the latest
                    updates, exclusive offers, and more. Follow us on Facebook,
                    Instagram, X, YouTube and TikTok to join our growing
                    community and never miss a moment of inspiration,
                    innovation, and connection. Together, we grow and create!
                  </p>
                  <a
                    href="https://www.facebook.com/CreativeScaleLab"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="btn">Follow Us Now!</button>
                  </a>
                </div>
              </div>
            </div>
            <div className="contact-info">
              <h1>Contact Information</h1>
              <div className="cards-box">
                <div className="info-card">
                  <h3>Email Address</h3>
                  <h5>Faris Megahed</h5>
                  <small>Executive Assistant</small>
                  <a href="mailto:Management@creativescalelab.org">
                    <button className="btn">
                      Management@creativescalelab.org
                    </button>
                  </a>
                </div>
                <div className="info-card">
                  <h3>Email Address</h3>
                  <h5>James Anderson</h5>
                  <small>Executive Assistant</small>
                  <a
                    href="https://wa.me/5712379205?text=Hello%20there!"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="btn">5712379205</button>
                  </a>
                </div>
              </div>
            </div>
            <div className="form-container">
              <div className="form-left">
                <div className="text-box">
                  <h1>
                    Bring your vision to life! Fill in your{" "}
                    <span className="title-word">Contact</span>
                    details now, and let’s start elevating your brand!
                  </h1>
                </div>
              </div>
              <div className="form-right">
                <form onSubmit={handleSubmit}>
                  <div className="row-1">
                    <div className="input-box">
                      <input
                        name="name"
                        type="text"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-box">
                      <input
                        name="companyName"
                        type="text"
                        placeholder="Company Name"
                        value={formData.companyName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-2">
                    <div className="input-box">
                      <input
                        name="mobile"
                        type="text"
                        placeholder="Phone Number"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-3">
                    <div className="input-box">
                      <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-4">
                    <select
                      name="inqueryType"
                      value={formData.inqueryType}
                      onChange={handleChange}
                    >
                      <option value="">Inquiry Type</option>
                      <option value="UI/UX Design">UI/UX Design</option>
                      <option value="Graphic Design">Graphic Design</option>
                      <option value="SEO & SEM">SEO & SEM</option>
                      <option value="Video Editing">Video Editing</option>
                      <option value="Content Creation">Content Creation</option>
                      <option value="Social Media Management">
                        Social Media Management
                      </option>
                      <option value="Motion Graphics">Motion Graphics</option>
                      <option value="Paid Social Media Advertising">
                        Paid Social Media Advertising
                      </option>
                      <option value="Digital Marketing">
                        Digital Marketing
                      </option>
                      <option value="None of the above">
                        None of the above
                      </option>
                    </select>
                  </div>
                  <div className="row-5">
                    <div className="input-box">
                      <textarea
                        placeholder="Write your message here..."
                        name="details"
                        value={formData.details}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <button
                    className="btn"
                    type="submit"
                    disabled={!isFormValid || isSending}
                    style={{
                      opacity: isFormValid ? 1 : 0.5,
                      pointerEvents: isFormValid ? "auto" : "none",
                    }}
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default Contact;
